export const lime = {
  300: 'hsla(66, 70%, 68%, 1)',
};

export type LimePalette = typeof lime;
